import React from 'react';

import { Table } from 'react-bootstrap';

import { isMobileResolution } from '../../../infrastructure/utils/common';
import {FullOrderBookingOption} from "../../../types/Order";

import EditOrderBookingOptionListItem from './EditOrderBookingOptionListItem';
import EditOrderBookingOptionRow from './EditOrderBookingOptionRow';

type Props<T> = {
  options: T[];
  uiElements: Record<string, React.ComponentType<T>>;
};

const EditOrderBookingOptions = <T extends FullOrderBookingOption>(props: Props<T>) => {
  if (isMobileResolution()) {
    return (
      <div className={`edit-order-form__booking-options--mobile`}>
        {props.options.map(item => (
          <EditOrderBookingOptionListItem
            key={item.lineItemId ?? item.id}
            item={item}
            uiElements={props.uiElements}
          />
        ))}
      </div>
    );
  }

  return (
    <div className={`edit-order-form__booking-options`}>
      <Table hover>
        <thead>
          <tr>
            <th>Action</th>
            {props.uiElements.attendees && <th>Attendees</th>}
            <th>Title & Description</th>
            <th>Duration</th>
            <th>Hours</th>
            <th>Interval</th>
            <th>Price</th>
            <th>Pricing&nbsp;Model</th>
          </tr>
        </thead>
        <tbody>
          {props.options.map(item => (
            <EditOrderBookingOptionRow
              key={item.lineItemId ?? item.id}
              item={item}
              uiElements={props.uiElements}
            />
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default EditOrderBookingOptions;
